





























import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import FaqCategories from '@/components/FaqCategories/FaqCategories.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';


@Component({
	name: 'FaqSettings',
  	components: { FaqCategories, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getFaqCategories();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingFaqCategories;
  	}
}
